import { render, staticRenderFns } from "./bnps_project_detail.vue?vue&type=template&id=48d6363a&scoped=true&"
import script from "./bnps_project_detail.vue?vue&type=script&lang=js&"
export * from "./bnps_project_detail.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./bnps_project_detail.vue?vue&type=style&index=1&id=48d6363a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6363a",
  null
  
)

export default component.exports